export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const AUTH = 'AUTH';
export const LOGIN = 'LOGIN';
export const DB_CONNECTION = 'DB_CONNECTION';
export const VALIDATE_CONNECTION = 'VALIDATE_CONNECTION'; 
export const SCHEMA_DATA = 'SCHEMA_DATA';
export const SET_DIV_COUNT = 'SET_DIV_COUNT';
export const REPORT_TEMPLATE_DATA_SAVE = 'REPORT_TEMPLATE_DATA_SAVE';
export const GET_REPORT_ON_DASHBOARD = 'GET_REPORT_ON_DASHBOARD';
export const GET_REPORT_FORMATE_DATA = 'GET_REPORT_FORMATE_DATA';
export const TEST_QUERY_CUSTOM = 'TEST_QUERY_CUSTOM';
export const CUSTOM_PREVIEW_DATA_TABLE = 'CUSTOM_PREVIEW_DATA_TABLE';
export const CUSTOM_PREVIEW_DATA_CHART = 'CUSTOM_PREVIEW_DATA_CHART';
export const LIST_OF_USER = 'LIST_OF_USER';
export const REMOVE_REPORT = 'REMOVE_REPORT';
export const UPDATE_REPORT = 'UPDATE_REPORT';
export const GENERATE_REPORT_BY_ID = 'GENERATE_REPORT_BY_ID';
export const LIST_OF_GROUP = 'LIST_OF_GROUP';
export const SAVE_USER = 'SAVE_USER';
export const LIST_OF_FEATURE = 'LIST_OF_FEATURE';
export const ADD_GROUP = 'ADD_GROUP';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const DELETE_USER = 'DELETE_USER';
export const ASSIGN_GROUP_ID_TO_USER = 'ASSIGN_GROUP_ID_TO_USER';
export const ASSIGN_REPORT_ID_TO_FEATURE = 'ASSIGN_REPORT_ID_TO_FEATURE';
export const ASSIGN_GROUP_ID_TO_REPORT = 'ASSIGN_GROUP_ID_TO_REPORT';
export const CREATE_CANVAS_PAGE = 'CREATE_CANVAS_PAGE';
export const CANVAS_FRAME_PAGE_DATA='CANVAS_FRAME_PAGE_DATA';
export const GET_REPORT_DETAIL_BASEON_GROUP_ID='GET_REPORT_DETAIL_BASEON_GROUP_ID';
export const GET_REPORT_DETAIL_BY_ID='GET_REPORT_DETAIL_BY_ID';
export const REST_API_DETAIL_SAVE='REST_API_DETAIL_SAVE';
export const LIST_OF_SCHEDULE_REPORT='LIST_OF_SCHEDULE_REPORT';
export const SAVE_SCHEDULE_REPORT='SAVE_SCHEDULE_REPORT';
export const UPDATE_CANVAS_FRAME_PAGE_DATA='UPDATE_CANVAS_FRAME_PAGE_DATA';
export const LIST_ASSIGN_GROUP_ID_TO_FEATURE='LIST_ASSIGN_GROUP_ID_TO_FEATURE';
export const DETAIL_SCHEDULE_REPORT_FOR_UPDATE='DETAIL_SCHEDULE_REPORT_FOR_UPDATE';
export const UPDATE_SCHEDULER='UPDATE_SCHEDULER';
export const REMOVE_SCHEDULER='REMOVE_SCHEDULER';
export const RESET_TEST_QUERY_CUSTOM='RESET_TEST_QUERY_CUSTOM';
export const RESET_DATA_WITH_BACK_BUTTON='RESET_DATA_WITH_BACK_BUTTON';
export const DATA_WITH_BACK_BUTTON = 'DATA_WITH_BACK_BUTTON';
export const GET_REPORTS_ACCESS_GROUP_ID = 'GET_REPORTS_ACCESS_GROUP_ID';
export const GET_REPORT_ACCESS_DETAIL = 'GET_REPORT_ACCESS_DETAIL';
export const GET_CHART_REPORT_DETAIL_BY_ID = 'GET_CHART_REPORT_DETAIL_BY_ID';
export const RESET_MESSAGE_TEST_QUERY_CUSTOM = 'RESET_MESSAGE_TEST_QUERY_CUSTOM';
export const RESET_MESSAGE_GROUP = 'RESET_MESSAGE_GROUP';
export const MESSAGE_ADD_GROUP = 'MESSAGE_ADD_GROUP';
export const CUSTOM_PREVIEW_DATA_BOX = 'CUSTOM_PREVIEW_DATA_BOX';
export const BOX_COLOR_DATA_SAVE = 'BOX_COLOR_DATA_SAVE';
export const GET_BOX_REPORT_DETAIL_BY_ID = 'GET_BOX_REPORT_DETAIL_BY_ID';
export const DELETE_CANVAS_FRAME = 'DELETE_CANVAS_FRAME';
export const DB_CONNECTION_SET_DEFAULT = 'DB_CONNECTION_SET_DEFAULT';
export const RESET_PASSWORD_MESSAGE = 'RESET_PASSWORD_MESSAGE';
export const TEST_QUERY_CUSTOM_MESSAGE_TYPE = 'TEST_QUERY_CUSTOM_MESSAGE_TYPE';
export const LOGIN_MESSAGE = 'LOGIN_MESSAGE';
export const CHECK_DASHBOARD_CANVAS_FRAME = 'CHECK_DASHBOARD_CANVAS_FRAME';
export const TEST_QUERY_CUSTOM_DRILL_DOWN = 'TEST_QUERY_CUSTOM_DRILL_DOWN';
export const RESET_TEST_QUERY_CUSTOM_DRILL_DOWN = 'RESET_TEST_QUERY_CUSTOM_DRILL_DOWN';
export const GET_LIST_OF_COLUMN_FIRST  = 'GET_LIST_OF_COLUMN_FIRST';
export const GET_LIST_OF_COLUMN_SECOND = 'GET_LIST_OF_COLUMN_SECOND';
export const REMOVE_LIST_OF_COLUMN_SECOND = 'REMOVE_LIST_OF_COLUMN_SECOND';
export const REMOVE_LIST_OF_COLUMN_FIRST = 'REMOVE_LIST_OF_COLUMN_FIRST';
export const SAVE_MAP_DATA_FOR_DRILLDOWN = 'SAVE_MAP_DATA_FOR_DRILLDOWN';
export const GET_DRILL_DOWN_DATA = 'GET_DRILL_DOWN_DATA';
export const INITIAL_GET_DRILL_DOWN_DATA = 'INITIAL_GET_DRILL_DOWN_DATA';
export const LIST_DASHBOARD_CANVAS_FRAME_NAME = 'LIST_DASHBOARD_CANVAS_FRAME_NAME';
export const LIST_DASHBOARD_CANVAS_FRAME_ACCESS = 'LIST_DASHBOARD_CANVAS_FRAME_ACCESS';
export const UPDATE_DASHBOARD_ACCESS = 'UPDATE_DASHBOARD_ACCESS';
export const CANVAS_FRAME_PAGE_DATA_FOR_COME_FIRST = 'CANVAS_FRAME_PAGE_DATA_FOR_COME_FIRST';
export const GET_FRAME_PAGE_DATA_BASE_ON_ID = 'GET_FRAME_PAGE_DATA_BASE_ON_ID';
export const LIST_DASHBOARD_CANVAS_FRAME_NAME_WITH = 'LIST_DASHBOARD_CANVAS_FRAME_NAME_WITH';
export const CHECK_DRILL_DOWN = 'CHECK_DRILL_DOWN';
export const  DEFAULT_CHECK_DRILL_DOWN = 'DEFAULT_CHECK_DRILL_DOWN';
export const IS_AUTHORIZE_USER = 'IS_AUTHORIZE_USER';
export const CHAT_BOT_TEXT_TO_QUERY= 'CHAT_BOT_TEXT_TO_QUERY';
export const CHAT_BOT_TEXT_TO_QUERY_RESET = 'CHAT_BOT_TEXT_TO_QUERY_RESET';
export const UPDATE_MAP_DATA_FOR_DRILLDOWN = 'UPDATE_MAP_DATA_FOR_DRILLDOWN';
export const GET_DRILLDOWN_FOR_UPDATE = 'GET_DRILLDOWN_FOR_UPDATE';
export const DEFAULT_GET_DRILLDOWN_FOR_UPDATE = 'DEFAULT_GET_DRILLDOWN_FOR_UPDATE'
export const UPDATE_GET_REPORT_ON_DASHBOARD = 'UPDATE_GET_REPORT_ON_DASHBOARD';
export const ADD_UPDATE_GET_REPORT_ON_DASHBOARD ='ADD_UPDATE_GET_REPORT_ON_DASHBOARD';
export const INITIAL_CHECK_DASHBOARD_CANVAS_FRAME = 'INITIAL_CHECK_DASHBOARD_CANVAS_FRAME';
export const REMOVE_OF_GROUP = 'REMOVE_OF_GROUP';
export const EDIT_OF_GROUP = 'EDIT_OF_GROUP';
export const EDIT_OF_GROUP_MESSAGE = 'EDIT_OF_GROUP_MESSAGE';
export const CHECK_REMOVE_OF_GROUP = 'CHECK_REMOVE_OF_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';
export const MESSAGE_CREATE_CANVAS_PAGE = 'MESSAGE_CREATE_CANVAS_PAGE';
export const UPDATE_CANVAS_FRAME_PAGE_DATA_MESSAGE = 'UPDATE_CANVAS_FRAME_PAGE_DATA_MESSAGE';
export const GET_CHART_REPORT_DETAIL_BY_ID_BEFORE = 'GET_CHART_REPORT_DETAIL_BY_ID_BEFORE';
export const SESSION_LOGOUT = 'SESSION_LOGOUT'

export const ASSIGN_GROUP_ID_TO_DBSOURCE = "ASSIGN_GROUP_ID_TO_DBSOURCE";
export const GET_DB_DETAILS = "GET_DB_DETAILS";
export const GET_DRILL_DOWN_DATA_VALUE = "GET_DRILL_DOWN_DATA_VALUE";

export const EXPORT_EXCEL_REPORT = "EXPORT_EXCEL_REPORT";
export const EXPORT_PDF_REPORT = "EXPORT_PDF_REPORT";
export const EXPORT_CSV_REPORT = "EXPORT_CSV_REPORT";
export const DEFAULT_EXPORT_CSV_REPORT = "DEFAULT_EXPORT_CSV_REPORT";
export const FILTER_DATA_REPORT_BY_ID = "FILTER_DATA_REPORT_BY_ID";
// export const GET_UNIQUE_COLUMN_VALUE = "GET_UNIQUE_COLUMN_VALUE";
export const FILTER_DATA_REPORT_BY_ID_DRILL = "FILTER_DATA_REPORT_BY_ID_DRILL";
export const GET_COLUMN_DRILL_DOWN_DATA = "GET_COLUMN_DRILL_DOWN_DATA";

export const SET_USERNAME = "SET_USERNAME";
export const REQUEST_OTP = "REQUEST_OTP";
export const REQUEST_OTP_FAILURE = "REQUEST_OTP_FAILURE";
export const VERIFY_OTP = "VERIFY_OTP";
export const RESEND_OTP = "RESEND_OTP";
export const UPLOAD_IMAGES = "UPLOAD_IMAGES";
export const FETCH_NAV_ICON = "FETCH_NAV_ICON";
export const FETCH_LOGIN_LOGO = "FETCH_LOGIN_LOGO";
export const FETCH_PDF_LOGO = "FETCH_PDF_LOGO";
export const RESET_PASSWORD_NEW = "RESET_PASSWORD_NEW";
export const GET_REPORT_DETAIL_BASEON_GROUP_ID_REPORTS = "GET_REPORT_DETAIL_BASEON_GROUP_ID_REPORTS";
export const FETCH_COLUMN_DRILLDOWN_DATA = "FETCH_COLUMN_DRILLDOWN_DATA";

export const UPDATE_DRILL_DASHBOARD_REPORT_DETAILS = "UPDATE_DRILL_DASHBOARD_REPORT_DETAILS";
export const DASHBOARD_DRILLDOWN_REPORT_DETAILS = "DASHBOARD_DRILLDOWN_REPORT_DETAILS";
export const GET_COLUMNS_DRILLDOWN_NAME = "GET_COLUMNS_DRILLDOWN_NAME";
export const GET_COLUMNS_DRILLDOWN_NAME_UPDATE = "GET_COLUMNS_DRILLDOWN_NAME_UPDATE";
export const STORE_DASHBOARD_COLUMN_DETAILS_SUCCEFULLY = "STORE_DASHBOARD_COLUMN_DETAILS_SUCCEFULLY";
export const STORE_DASHBOARD_COLUMN_DETAILS_SUCCEFULLY_UPDATE = "STORE_DASHBOARD_COLUMN_DETAILS_SUCCEFULLY_UPDATE";
export const UPDATE_DRILLDOWN_DASHBOARD_MAPPING = "UPDATE_DRILLDOWN_DASHBOARD_MAPPING";
export const UPDATE_DRILLDOWN_DASHBOARD_MAPPING_SAVE = "UPDATE_DRILLDOWN_DASHBOARD_MAPPING_SAVE";
export const SET_DRILLDOWN_TYPE_CHECK = "SET_DRILLDOWN_TYPE_CHECK";
export const UPDATE_MAP_DATA_FOR_DRILLDOWN_TYPE_SAVE = "UPDATE_MAP_DATA_FOR_DRILLDOWN_TYPE_SAVE";
export const SAVE_MAP_DATA_FOR_DRILLDOWN_TYPE_SAVE = "SAVE_MAP_DATA_FOR_DRILLDOWN_TYPE_SAVE";

export const LIST_OF_FAVOURATE_INVENTORY = "LIST_OF_FAVOURATE_INVENTORY";
export const LIST_OF_ALL_INVENTORY = "LIST_OF_ALL_INVENTORY";
export const LIST_OF_ALL_SERVER_DETAILS = "LIST_OF_ALL_SERVER_DETAILS";
export const LIST_OF_MONITORING_PARAMS = "LIST_OF_MONITORING_PARAMS";

export const GET_LIST_OF_COLUMNS = "GET_LIST_OF_COLUMNS";
export const GET_INVENTORY_DETAIL = "GET_INVENTORY_DETAIL";
export const GET_LIST_OF_TABLES = "GET_LIST_OF_TABLES";
export const SAVE_CONNECTION = "SAVE_CONNECTION";
export const SAVE_TEMPLATE = "SAVE_TEMPLATE";
export const FETCH_TEMPLATES = "FETCH_TEMPLATES";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
export const FETCH_SCHEMA = "FETCH_SCHEMA";
export const TOGGLE_FAVORITE = "TOGGLE_FAVORITE";
export const FETCH_FAVORITE_INVENTORY = "FETCH_FAVORITE_INVENTORY"
export const GET_UNIQUE_VALUES = "GET_UNIQUE_VALUES"
export const SAVE_CONNECTION_PENDING = "SAVE_CONNECTION_PENDING";
export const SAVE_CONNECTION_SUCCESS = "SAVE_CONNECTION_SUCCESS";
export const SAVE_CONNECTION_ERROR = "SAVE_CONNECTION_ERROR";
export const SAVE_CONNECTION_EMPTY = "SAVE_CONNECTION_EMPTY";
export const DELETE_FAVORITES = "DELETE_FAVORITES";
export const DELETE_CONNECTION = "DELETE_CONNECTION";
export const LIST_OF_INVENTORY_ACCESS_RIGHT = "LIST_OF_INVENTORY_ACCESS_RIGHT";
export const ASIGN_INVENTORY_ACCESS_TO_GROUP = "ASIGN_INVENTORY_ACCESS_TO_GROUP";



